import { DynamicHeadline } from "../DynamicHeadline"
import Section, { parseColors } from "../Section"
import styles from "./Tools.module.scss"
import { Toolset } from "./Toolset"

export const Tools = ({ data = {}, colors }) => {
  const {
    toolsets,
    dynamic_headline: dynamicHeadline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    ankerslug,
  } = data

  const { isLightBackground } = parseColors({ colors })

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      id={ankerslug}
      colors={colors}
    >
      {dynamicHeadline && (
        <DynamicHeadline
          headlineType={headlineType.value}
          headlineAppearance={headlineAppearance.value}
          className={styles.toolsHeadline}
        >
          {dynamicHeadline}
        </DynamicHeadline>
      )}
      <div className={styles.toolsToolsetWrapper}>
        {toolsets &&
          toolsets.map((toolset, i) => (
            <Toolset
              key={i}
              set={toolset}
              borderColor={isLightBackground ? "black" : "white"}
            />
          ))}
      </div>
    </Section>
  )
}

export default Tools
